<template>
    <div class="faqsItem__item" :id="faqItemId">
        <div :class="titleClass" @click="handleTitleClick">
            <span v-text="item.title" class="faqsItem__item__title"></span>
            <img :class="titleIconClass" src="@/assets/images/decoration/arrow-down-black.png">
        </div>
        <div :class="answerClass" v-html="item.answer" @click.prevent="handleParagraphClickEvent"></div>
    </div>
</template>

<script>
export default {
    name: 'FaqItem',
    data() {
        return {
            isOpen: false,
        };
    },
    props: {
        item: {
            required: true,
            type: Object,
        },
        expand: {
            default: false,
            type: Boolean,
        },
    },
    mounted() {
        this.isOpen = this.expand;

        if (this.expand) {
            this.scrollToFaqItem();
        }

        this.handleItemSelected();
    },
    methods: {
        handleItemSelected() {
            this.$root.$on('faqItemSelected', (item) => {
                const isThisPath = this.item.path === item.path;

                if (isThisPath) {
                    this.isOpen = !this.isOpen;
                    this.scrollToFaqItem();
                } else {
                    this.isOpen = false;
                }
            });
        },
        scrollToFaqItem() {
            setTimeout(() => {
                this.$scrollTo('#' + this.faqItemId, 500, { offset: -300 });
            }, 50);
        },

        handleParagraphClickEvent(event) {
            let target = event.target;

            // We can't use router links in answers. Vue parses them not like templates but like text or HTML.
            // So we add the data-name property including a route name to a-tags. This listener method pushes
            // these routes.
            if (target && target.dataset && target.dataset.name) {
                event.preventDefault();
                this.$router.push({ name: target.dataset.name });
            }
        },

        handleTitleClick() {
            this.$root.$emit('faqItemSelected', this.item);
        },
    },
    computed: {
        faqItemId() {
            return 'id' + this.item.path.replace(/\//g, '-');
        },
        titleClass() {
            let classStr = 'faqsItem__title';

            return this.isOpen ? `${classStr} ${classStr}--active` : classStr;
        },
        titleIconClass() {
            let classStr = 'faqsItem__titleIcon';

            return this.isOpen ? `${classStr} ${classStr}--active` : classStr;
        },
        answerClass() {
            let classStr = 'accordion__faq';

            return this.isOpen ? `${classStr} ${classStr}--active` : classStr;
        },
    },
    beforeDestroy() {
        this.$root.$off('faqItemSelected');
    },
};
</script>
